"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PKCEChallengeProvider = void 0;
var pkce_challenge_1 = __importDefault(require("pkce-challenge"));
var MemoryLastCodeVerifierProvider_1 = require("./MemoryLastCodeVerifierProvider");
var PKCEChallengeProvider = /** @class */ (function () {
    function PKCEChallengeProvider(lastPKCEVerifierProvider) {
        var _this = this;
        this.lastPKCEVerifierProvider = lastPKCEVerifierProvider;
        this.createChallenge = function () {
            var _a = (0, pkce_challenge_1.default)(), code_verifier = _a.code_verifier, code_challenge = _a.code_challenge;
            _this.lastPKCEVerifierProvider.store({ code_verifier: code_verifier });
            return { code_verifier: code_verifier, code_challenge: code_challenge };
        };
        this.getLastVerifier = function () {
            return _this.lastPKCEVerifierProvider.getLastVerifier();
        };
    }
    PKCEChallengeProvider.inject = function () { return [MemoryLastCodeVerifierProvider_1.MemoryLastCodeVerifierProvider]; };
    return PKCEChallengeProvider;
}());
exports.PKCEChallengeProvider = PKCEChallengeProvider;
//# sourceMappingURL=PKCEChallengeProvider.js.map